export const AUDIO_PLAYER_HEIGHT = 56;

export const PodcastClickState = {
    Play: "play",
    Pause: "pause",
} as const;

export type TPodcastClickState = (typeof PodcastClickState)[keyof typeof PodcastClickState];
